import {
  changeProductColorByBpc,
  changeProductColorByBps,
  eventMpMaker,
  initAfterPlacingProductFaces,
  makeFcanvasBasic,
  renderFcanvasByBpcfA,
} from '../../../../Maker/F/mp_maker.js';
import { NewMakerCallConditionPopupF } from '../../../CallConditionPopup/F/Function/module/NewMakerCallConditionPopupF.js';
import { renderVisibleWhenSelected, selectFaceInitA } from '../../../../Maker/F/select_faces.js';
import { getCurrentFcanvas, getCvDesigns } from '../../../../Maker/F/Fcanvas/cv_object.js';
import { loadDefaultFonts } from '../../../../Maker/F/text.js';
import { delay, each, find, go, some, tap } from 'fxjs/es';
import {
  marpplizerMode,
  setCanvasContainerSizeAndMpMakerHeight,
} from '../../../../Maker/F/f_canvas_setting.js';
import { $addClass, $qs, $removeClass } from 'fxdom/es';
import { getFontColors } from '../../../../Maker/F/CvTextImage/fs.js';
import { getFonts } from '../../../../Maker/F/util.js';
import { SVGEditorProductDetailF } from '../../../../SVGEditor/ProductDetail/F/Function/module/SVGEditorProductDetailF.js';
import { BpOptionUploadTypeS } from '../../../../BpOption/UploadType/S/Function/module/BpOptionUploadTypeS.js';
import { OMPCoreUtilS } from '../../../../OMP/Core/Util/S/Function/module/OMPCoreUtilS.js';
import { OMPCoreUtilF } from '../../../../OMP/Core/Util/F/Function/module/OMPCoreUtilF.js';
import { NewMakerUtilF } from '../../../Util/F/Function/module/NewMakerUtilF.js';
import {
  getBaseProductColorFacesInMaker,
  getBaseProductInMaker,
  getFcanvass,
  getProductColorInMaker,
  setProductFaces2Value,
} from '../../../../Maker/F/getSth.js';
import { BpOptionF } from '../../../../BpOption/F/Function/module/BpOptionF.js';
import { VectorEditorConstantS } from '../../../../VectorEditor/S/Constant/module/VectorEditorConstantS.js';
import { BpOptionConstantS } from '../../../../BpOption/S/Constant/module/BpOptionConstantS.js';
import { UtilF } from '../../../../Util/F/Function/module/UtilF.js';
import { makeFakeMpMakerSize } from '../../../../Maker/F/fake_mp_maker.js';
import { addCvPreview } from '../../../../Maker/F/CvPreview/cv_object.js';
import { NewMakerLegacyF } from '../../../Legacy/F/Function/module/NewMakerLegacyF.js';
import { makeBpcfAvgSize } from '../../../../Maker/F/canvas_size.js';
import { checkIsOverflowInCurrentFace } from '../../../../Maker/F/overflow.js';
import { NewMakerEndServiceF } from './module/NewMakerEndServiceF.js';
import { renderMakerPageShade } from '../../../../Maker/F/CvPreview/Shade/render.js';
import { dealWithVideoUrl } from '../../../../Maker/F/CvBpcfVideo/fs.js';
import { NewMakerCvObjectUtilS } from '@modules/NewMaker/CvObject/Util/S/Function/module/NewMakerCvObjectUtilS.js';
import { ConfigSentryF } from '@modules/Config/Sentry/F/Function/module/ConfigSentryF.js';

function start() {
  window.localStorage.setItem('start_bad_computing_power_test', 'start');
}

function end() {
  window.localStorage.setItem('start_bad_computing_power_test', 'end');
}

function isBadComputing() {
  return window.localStorage.getItem('start_bad_computing_power_test') === 'start';
}

const cvObj = {
  hasEmbro: (obj) => {
    return go(
      NewMakerCvObjectUtilS.getFlattenCvDesigns([obj]),
      some((obj) => obj?._data?.is_embro),
    );
  },
};

export const core = {
  cvObj,
  changeProductBps: async (base_product_size_id, idx = 0) => {
    const is_bad_computing_power_test = isBadComputing();
    try {
      start();
      changeProductColorByBps({ id: base_product_size_id });
      await go(
        getBaseProductColorFacesInMaker(),
        _p.each(async function (bpcf, i) {
          if (is_bad_computing_power_test) {
            await delay(500, () => {});
          }
          await renderFcanvasByBpcfA([bpcf, i]);
        }),
        async function () {
          G.mp.maker.bpcf_size = makeBpcfAvgSize();
          checkIsOverflowInCurrentFace();
          G.mp.maker.center_mode.init();
        },
      );
      NewMakerCallConditionPopupF.uiRender();
      if (NewMakerCallConditionPopupF.is_real_mapping_confirm_popup()) {
        renderVisibleWhenSelected(getCurrentFcanvas());
      }
      NewMakerEndServiceF.userProduct.updateBps({ base_product_size_id });
      if (!is_bad_computing_power_test) {
        end();
      }
    } catch (e) {
      if (Number.isNaN(idx)) {
        throw e;
      }
      if (idx > 0) {
        ConfigSentryF.error(e, { tags: { module: 'mp_maker', type: 'changeProductBps-1' } });
        await $.alert(T('maker_error_alert::문제발생-새로고침'));
        window.location.reload();
      } else {
        ConfigSentryF.error(e, { tags: { module: 'mp_maker', type: 'changeProductBps-2' } });
        await delay(3000, () => {});
        await core.changeProductBps(base_product_size_id, ++idx);
      }
    }
  },
  changeProductBpc: async (base_product_color_id, idx = 0) => {
    const is_bad_computing_power_test = isBadComputing();
    try {
      start();
      const bpc = go(
        box.sel('maker->product_color->_->base_product->_->base_product_colors'),
        find((bpc) => bpc.id == base_product_color_id),
      );
      changeProductColorByBpc(bpc);
      await go(
        getBaseProductColorFacesInMaker(),
        _p.each(async function (bpcf, i) {
          if (is_bad_computing_power_test) {
            await delay(500, () => {});
          }
          await renderFcanvasByBpcfA([bpcf, i]);
        }),
      );
      await G.mp.maker.reset_layer();
      NewMakerEndServiceF.userProduct.updateBpc(getProductColorInMaker());
      await dealWithVideoUrl();
      if (!is_bad_computing_power_test) {
        end();
      }
    } catch (e) {
      if (Number.isNaN(idx)) {
        throw e;
      }

      if (idx > 0) {
        await $.alert(T('maker_error_alert::문제발생-새로고침'));
        window.location.reload();
        ConfigSentryF.error(e, { tags: { module: 'mp_maker', type: 'changeProductBpc-1' } });
      } else {
        await delay(3000, () => {});
        await core.changeProductBpc(base_product_color_id, ++idx);
        ConfigSentryF.error(e, { tags: { module: 'mp_maker', type: 'changeProductBpc-2' } });
      }
    }
  },
  changeProductBpsAndBpcAndProductFaces2AndSelectedOptionGroup: ({
    product_faces2,
    base_product_size_id,
    base_product_color_id,
    selected_option_group,
  }) => {
    const product = box().maker.product_color;
    if ([VectorEditorConstantS.EDITOR_TYPES].includes(product._.base_product.maker_type)) return;
    product.product_faces2 = product_faces2;
    product._.selected_option_group = selected_option_group;
    const bpc = go(
      box.sel('maker->product_color->_->base_product->_->base_product_colors'),
      find((bpc) => bpc.id == base_product_color_id),
    );
    changeProductColorByBpc(bpc);
    changeProductColorByBps({ id: base_product_size_id });
  },
  onDesignStateChanged: () => {
    if (G.mp.maker.mconManager?.productMconThemeInstance) {
      setProductFaces2Value();
      /* G.mp.maker.reset_box_data 전에 무조건 와야함 */
      if (!NewMakerEndServiceF.makerStatus.isVectorEditor()) {
        G.mp.maker.mconManager.syncToProductForCanvasEditor();
      }
    }
    G.mp.maker.reset_box_data();
    if (NewMakerEndServiceF.userProduct) {
      NewMakerEndServiceF.userProduct.updatePrice();
    }
  },
  initialize: async (target_el, maker_html, afterDesignSet) => {
    go([$qs('html'), $qs('body')], each($addClass('maker_page')));
    $.don_loader_start();
    // addMakerPageClass();
    G.mp.maker.initWindowSizeInMaker();
    const product_color = box.sel('maker->product_color');
    await go(
      maker_html,
      $.el,
      $.prepend_to(target_el),
      async () => {
        setCanvasContainerSizeAndMpMakerHeight();
        await go(
          makeFcanvasBasic($('#maker .board .canvass canvas'), true),
          () =>
            _p.each(getFcanvass(), (f_canvas) => {
              G.mp.maker.canvas_event(f_canvas);
            }),
          () =>
            _p.each(getFcanvass(), (f_canvas) =>
              renderMakerPageShade(f_canvas, getCvDesigns(f_canvas._objects)),
            ),

          async () => {
            if (typeof afterDesignSet === 'function') await afterDesignSet();
          },
          /* 초기 init makeFcanvasBasic */
          () => initAfterPlacingProductFaces(true),
          async () => {
            await go(getCurrentFcanvas(), (f_canvas) => f_canvas.preview && addCvPreview(f_canvas));
          },
        );
      },
      () => {
        /*event*/
        eventMpMaker();
        marpplizerMode(window.innerWidth > 1410 ? 'basic' : 'short');
      },
      tap(async function () {
        const bp_option_groups_el = $qs('.bp_option_groups');
        if (bp_option_groups_el) {
          /* 필요할까???? */
          const selected_option_group = BpOptionF.makeSelectedOptionGroup(bp_option_groups_el);
          box().maker.product_color._.selected_option_group = selected_option_group;
        }
        if (
          [VectorEditorConstantS.STICKER_EDITOR, BpOptionConstantS.MASKING_TAPE_EDITOR].includes(
            getBaseProductInMaker().maker_type,
          )
        ) {
          /* 마스킹테이프만 */
          await BpOptionF.stickerMaskingTapeBpOptionInit();
        }
        const maker_frame_el = $qs('#maker_frame');
        /* after setting */
        if (maker_frame_el?.dataset?.is_vector === 'true') {
          /* vector 에디터 */
          const bp_option_groups_el = $qs('.bp_option_groups');
          await SVGEditorProductDetailF.vectorEditorPreviewInit(bp_option_groups_el);
        }
        // NewMakerPropertyBaseProductF.pdfFilePossible.activeTippy();
        const pdf_printing_file =
          BpOptionUploadTypeS.UPLOAD_TYPE.option.direct.getPrintingFile(product_color);
        if (pdf_printing_file && OMPCoreUtilS.isExpired(pdf_printing_file)) {
          /* pdf_printing_file */
          await OMPCoreUtilF.alertPdfFileExpired({ product: product_color });
          $.don_loader_start();
          NewMakerUtilF.reload.baseProduct();
          setTimeout(() => {
            $.don_loader_end();
          }, 5000);
        }
      }),
      async () => {
        if (!UtilF.isLegacyMobile()) {
          await selectFaceInitA();
        } else {
          makeFakeMpMakerSize();
          await NewMakerLegacyF.swiperInit();
        }
        go([$qs('html'), $qs('body')], each($removeClass('mp_maker_not_ready')));
        loadDefaultFonts();
        getFontColors();
        getFonts();
        // if ($1('html#dream_factory')) {
        //   if (canGoBlueLIne()) initBlueLine();
        //   if (
        //     getBaseProductFacesInMaker()[0].size_faces[0].items &&
        //     getBaseProductFacesInMaker()[0].size_faces[0].items[0]?.px?.width
        //   )
        //     cvPrintItemEvent();
        //   if (box.sel('user_made_product_color')) {
        //     const pf = box.sel('user_made_product_color->product_faces2->value');
        //     initUploadAllPrintableFilesBtn();
        //     initPrevProductFaces(pf);
        //     $.append(
        //       $1('html#dream_factory ul.decoration_menu_for_pc'),
        //       _p.t$(
        //         '\
        //       li.worker_folder.circle_icon\
        //         .icon\
        //         .text Worker\
        //     ',
        //       )(),
        //     );
        //   }
        // }
      },
    );
  },
};
